<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs" />
        <div class="content">
            <h1 class="title">👉 Прирост подписчиков</h1>

            <v-row class="filters ma-0">
                <CustomActivatorSelect :items="channelOptions" :value="filters.channel" :transition="false" :multiple="false" @input="filters.channel = $event">
                    <template v-slot:activator="{ selected, _id }">
                        <BaseInputOutlined label="Канал" hide-details persistent-label class="select-input" append-icon="mdi-menu-down" :id="_id" :value="selected ? selected.name : ''" readonly />
                    </template>
                </CustomActivatorSelect>

                <CustomActivatorSelect :items="statusOptions" :value="filters.status" :transition="false" :multiple="false" @input="filters.status = $event">
                    <template v-slot:activator="{ selected, _id }">
                        <BaseInputOutlined label="Статус подписки" hide-details persistent-label class="select-input" append-icon="mdi-menu-down" :id="_id" :value="selected ? selected.name : ''" readonly />
                    </template>
                </CustomActivatorSelect>

                <v-menu v-if="showPeriodFilter" v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <BaseInputOutlined class="period-input" color="mainNew" :value="periodLabel" :label="periodFilterLabel" persistent-label readonly hide-details v-bind="attrs" v-on="on" />
                    </template>
                    <v-date-picker v-model="periodDates" range no-title scrollable color="mainNew" @input="onDateChange">
                        <v-spacer />
                        <v-btn text color="mainNew" @click="dateMenu = false">Закрыть</v-btn>
                    </v-date-picker>
                </v-menu>
            </v-row>

            <v-row class="ma-0 mt-3 mb-4 actions-row">
                <v-btn color="mainNew" class="white--text" :loading="loading" @click="applyFilters">ПРИМЕНИТЬ</v-btn>
                <v-btn outlined class="ml-3" :disabled="loading" @click="resetFilters">СБРОСИТЬ</v-btn>
                <div v-if="chartFilter" class="chart-filter-chip ml-3">
                    {{ chartFilterText }}
                    <v-btn icon x-small @click="clearChartFilter"><v-icon small>mdi-close</v-icon></v-btn>
                </div>
            </v-row>

            <div class="widget-cards mb-4">
                <div class="widget-card-col" v-for="banner in segmentBanners" :key="banner.key">
                    <v-card outlined class="widget-card">
                        <div class="widget-card__head">
                            <div class="widget-card__icon">
                                <span class="widget-card__emoji" aria-hidden="true">{{ banner.emoji }}</span>
                            </div>
                            <div class="widget-card__title">{{ banner.title }}</div>
                        </div>
                        <div class="widget-card__actions">
                            <v-btn
                                v-if="!banner.segment"
                                color="mainNew"
                                small
                                class="white--text"
                                :disabled="!canEditSegmentation"
                                @click="openSegmentationMaster(banner.key)"
                            >
                                Создать
                            </v-btn>
                            <v-btn
                                v-else-if="!banner.segment.isRunning"
                                color="mainNew"
                                small
                                class="white--text"
                                :disabled="!canEditSegmentation"
                                @click="openSegmentationMaster(banner.key)"
                            >
                                Запустить
                            </v-btn>
                            <template v-else>
                                <v-tooltip bottom max-width="320">
                                    <template #activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on" class="d-inline-block">
                                            <v-btn small outlined @click="openStatistics(banner.key)">Статистика</v-btn>
                                        </span>
                                    </template>
                                    <span>{{ segmentationActionTooltips.viewAnalytics }}</span>
                                </v-tooltip>
                                <v-btn icon small class="ml-1" :disabled="!canEditSegmentation" @click="openSegmentationMaster(banner.key)">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                        </div>
                    </v-card>
                </div>
                <div class="widget-card-col" v-if="showMissingChannelsBanner">
                    <div class="channels-recommend-banner">
                        <div class="channels-recommend-banner__icon channels-recommend-banner__icon--rocket">
                            <span class="channels-recommend-banner__rocket" aria-hidden="true">🚀</span>
                        </div>
                        <div class="channels-recommend-banner__content">
                            <div class="channels-recommend-banner__title">Подключите дополнительные каналы</div>
                            <div class="channels-recommend-banner__text">
                                У вас подключён только MAX Business. Добавьте WhatsApp или Telegram, чтобы не терять связь с клиентами при отписке от бота
                            </div>
                        </div>
                        <div class="channels-recommend-banner__actions">
                            <v-btn
                                small
                                color="#378EFF"
                                dark
                                :elevation="0"
                                class="channels-recommend-banner__btn"
                                @click="goToChannelsSetup"
                            >
                                ПОДКЛЮЧИТЬ КАНАЛ
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>

            <div class="summary mt-5">
                <span class="summary__label">{{ summaryTitle }}:</span>
                <b>{{ filteredRows.length }}</b>
                <!-- <b>{{ filteredRows.length }}</b> из <b>{{ allClientsCount }}</b>
                <span class="summary__percent">({{ summaryPercent }}%)</span>
                <v-tooltip bottom max-width="260px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon x-small color="#98A0AA" class="summary__hint-icon" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                    </template>
                    <span>Вся клиентская база за весь период</span>
                </v-tooltip> -->
            </div>
            <v-data-table
                class="mt-3"
                :headers="headers"
                :items="filteredRows"
                :loading="loading"
                :page.sync="tablePage"
                :items-per-page.sync="itemsPerPage"
                :footer-props="tableFooterProps"
                @click:row="openClientSidebar"
            >
                <template v-slot:item.status="{ item }">
                    <div class="status-cell">
                        <span class="status-dot" :class="item.status === 'Подписан' ? 'green' : 'red'" />
                        {{ item.status }}
                    </div>
                </template>
            </v-data-table>

            <h2 class="graph-title">Динамика подписок и отписок по месяцам</h2>
            <div class="metrics-chart-wrap">
                <div class="chart-main-row">
                    <div class="chart-sidebar">
                        <div class="chart-controls">
                            <div class="chart-controls-left">
                                <span class="metric-name-label">Показать на графике:</span>
                                <CustomActivatorSelect :items="chartModeOptions" :value="chartMode" :transition="false" :multiple="false" @input="chartMode = $event">
                                    <template v-slot:activator="{ selected, _id }">
                                        <BaseInputOutlined
                                            class="chart-mode-input"
                                            hide-details
                                            persistent-label
                                            append-icon="mdi-menu-down"
                                            :id="_id"
                                            :value="selected ? selected.name : ''"
                                            readonly
                                        />
                                    </template>
                                </CustomActivatorSelect>
                            </div>
                            <div class="chart-scale">
                                <div class="scale-labels">
                                    <div
                                        class="scale-label"
                                        v-for="(tick, index) in chartScaleTicks"
                                        :key="'scale-' + index + '-' + tick.value"
                                        :style="{ top: tick.topPercent + '%' }"
                                    >
                                        {{ tick.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="chart-periods-row">
                        <div v-for="month in monthStats" :key="`${month.year}-${month.month}`" class="chart-cell" :class="{ 'chart-cell--selected': isChartCellSelected(month) }">
                            <v-tooltip bottom :open-delay="500" max-width="280px">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="mini-chart" v-bind="attrs" v-on="on">
                                        <div class="chart-grid-lines">
                                            <div
                                                v-for="(tick, idx) in chartScaleTicks"
                                                :key="'grid-' + month.name + '-' + idx + '-' + tick.value"
                                                class="grid-line"
                                                :style="{ top: tick.topPercent + '%' }"
                                            />
                                        </div>
                                        <div class="chart-bars-wrap">
                                            <div
                                                v-if="showSubsBar"
                                                class="chart-bar chart-bar--subs"
                                                :style="{ height: barHeightPercent(month.subs) + '%' }"
                                                @click.stop="toggleChartFilter(month, 'true')"
                                            />
                                            <div
                                                v-if="showUnsubsBar"
                                                class="chart-bar chart-bar--unsubs"
                                                :style="{ height: barHeightPercent(month.unsubs) + '%' }"
                                                @click.stop="toggleChartFilter(month, 'false')"
                                            />
                                        </div>
                                    </div>
                                </template>
                                <div class="chart-tooltip-body">
                                    <div class="chart-tooltip-title">{{ month.periodLabel }}</div>
                                    <div v-if="showSubsBar">Подписки: <span class="chart-tooltip-pos">+{{ month.subs }}</span></div>
                                    <div v-if="showUnsubsBar">Отписки: <span class="chart-tooltip-neg">-{{ month.unsubs }}</span></div>
                                </div>
                            </v-tooltip>
                            <div class="period-label">{{ month.short }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="legend">
                <span v-if="showSubsBar"><i class="legend-dot green"></i> Подписки</span>
                <span v-if="showUnsubsBar" :class="{ 'ml-4': showSubsBar }"><i class="legend-dot red"></i> Отписки</span>
            </div>
        </div>

        <v-dialog v-model="segmentationDialog" max-width="1360px" max-height="95%">
            <v-card>
                <v-card-title class="headline">{{ segmentationDialogTitle }}</v-card-title>
                <v-card-text>
                    <div class="segmentation-form-grid">
                        <div class="segmentation-form-main">
                            <v-text-field
                                v-model="segmentationForm.name"
                                label="Название активации"
                                outlined
                                dense
                                hide-details
                                class="mb-3"
                            />
                            <v-text-field
                                v-if="!segmentationAudienceHasSchema"
                                :value="segmentationAudienceRuleLabel"
                                label="Выбранная аудитория"
                                outlined
                                dense
                                readonly
                                hide-details
                                class="mb-3"
                            />
                            <div v-if="segmentationAudiencesLoading" class="py-6 d-flex justify-center">
                                <SpinnerLoader />
                            </div>
                            <div v-else-if="segmentationAudienceHasSchema" class="segmentation-audience-params mb-2">
                                <AudienceTitleWithParams
                                    :key="'seg-aud-' + (segmentationAudienceTemplateForMaster && segmentationAudienceTemplateForMaster.id)"
                                    :mode="segmentationAudienceEditMode"
                                    type="default"
                                    :mass-edit="true"
                                    :current-activation="segmentationMassEditActivationStub"
                                    v-model="segmentationAudienceFilterValues"
                                    :audience="segmentationAudienceTemplateForMaster"
                                    :lists="segmentationAudienceLists"
                                    @select-audience="() => {}"
                                />
                            </div>
                            <template v-else>
                                <div class="segmentation-section-title">Настройте условия:</div>
                                <div class="segmentation-rule-row mb-3">
                                    <span>Клиенты, которые</span>
                                    <v-text-field
                                        :value="segmentationDefinition?.key === 'safe_mailing' ? 'подписаны' : 'не подписаны'"
                                        outlined
                                        dense
                                        readonly
                                        hide-details
                                        class="segmentation-inline-input"
                                    />
                                    <span>на ваш канал</span>
                                    <v-text-field
                                        value="MAX Business"
                                        outlined
                                        dense
                                        readonly
                                        hide-details
                                        class="segmentation-inline-input"
                                    />
                                </div>
                            </template>
                            <div class="segmentation-script-header">
                                <span>Части скрипта</span>
                            </div>
                            <MessageSettings
                                v-model="segmentationActivationDraft"
                                :automailValidate="segmentationAutomailValidate"
                                :scriptTextPlaceholder="segmentationScriptPlaceholder"
                                :extraMessageVars="segmentationExtraMessageVars"
                                :previewTextTransform="segmentationPreviewTextTransform"
                            />
                        </div>
                        <div class="segmentation-form-side">
                            <CustomActivatorSelect
                                :items="segmentationChannelOptions"
                                :value="segmentationForm.channel"
                                :transition="false"
                                :multiple="false"
                                @input="segmentationForm.channel = $event"
                            >
                                <template v-slot:activator="{ selected, _id }">
                                    <BaseInputOutlined
                                        label="Канал отправки"
                                        hide-details
                                        persistent-label
                                        append-icon="mdi-menu-down"
                                        :id="_id"
                                        :value="selected ? selected.name : ''"
                                        readonly
                                    />
                                </template>
                            </CustomActivatorSelect>
                            <div class="segmentation-time-limits">
                                <TimeLimitsSettings
                                    v-model="segmentationActivationDraft"
                                    :automailValidate="segmentationAutomailValidate"
                                />
                            </div>
                            <div class="segmentation-side-title mt-4">Лимиты автоматической отправки</div>
                            <v-text-field v-model.number="segmentationForm.messagesInBatch" label="Сообщений в 1 отправку" outlined dense hide-details />
                            <v-text-field v-model.number="segmentationForm.messagesPerDay" label="Сообщений за 1 день" outlined dense hide-details class="mt-3" />
                            <v-text-field v-model.number="segmentationForm.minutesBetween" label="Минут между 2 отправками" outlined dense hide-details class="mt-3" />
                            <v-menu
                                v-model="segmentationStartDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDateForInput(segmentationForm.startDate)"
                                        label="Дата начала рассылки"
                                        outlined
                                        dense
                                        readonly
                                        hide-details
                                        class="mt-3"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="segmentationForm.startDate"
                                    no-title
                                    scrollable
                                    color="mainNew"
                                    @input="segmentationStartDateMenu = false"
                                />
                            </v-menu>
                            <v-menu
                                v-model="segmentationEndDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDateForInput(segmentationForm.endDate)"
                                        label="Дата конца рассылки"
                                        outlined
                                        dense
                                        readonly
                                        hide-details
                                        class="mt-3"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="segmentationForm.endDate"
                                    no-title
                                    scrollable
                                    color="mainNew"
                                    @input="segmentationEndDateMenu = false"
                                />
                            </v-menu>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions class="px-6 pb-5 segmentation-dialog-actions">
                    <v-btn outlined :disabled="segmentationLoading" @click="cancelSegmentationChanges">Отмена</v-btn>
                    <template v-if="!isActiveSegmentRunning">
                        <v-tooltip bottom max-width="320">
                            <template #activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="d-inline-block">
                                    <v-btn color="mainNew" class="white--text" :loading="segmentationLoading" :disabled="segmentationLoading || !canLaunchSegmentation || showSegmentationIntervalWarning" @click="saveSegmentAndRefresh(true)">Запустить сейчас</v-btn>
                                </span>
                            </template>
                            <span>{{ segmentationStartNowTooltip }}</span>
                        </v-tooltip>
                        <v-tooltip bottom max-width="320">
                            <template #activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="d-inline-block">
                                    <v-btn color="mainNew" outlined :loading="segmentationLoading" :disabled="segmentationLoading || !canSubmitSegmentation || showSegmentationIntervalWarning" @click="saveSegmentAndRefresh(false)">Сохранить без запуска</v-btn>
                                </span>
                            </template>
                            <span>{{ segmentationActionTooltips.saveWithoutStart }}</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-tooltip bottom max-width="320">
                            <template #activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="d-inline-block">
                                    <v-btn color="mainNew" class="white--text" :loading="segmentationLoading" :disabled="segmentationLoading || !canSubmitSegmentation || showSegmentationIntervalWarning" @click="saveSegmentAndRefresh(true)">Сохранить</v-btn>
                                </span>
                            </template>
                            <span>{{ segmentationActionTooltips.saveWhileRunning }}</span>
                        </v-tooltip>
                        <v-tooltip bottom max-width="320">
                            <template #activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="d-inline-block">
                                    <v-btn color="error" outlined :loading="segmentationLoading" :disabled="segmentationLoading || !canSubmitSegmentation || showSegmentationIntervalWarning" @click="saveSegmentAndRefresh(false)">Остановить отправку</v-btn>
                                </span>
                            </template>
                            <span>{{ segmentationActionTooltips.stopSending }}</span>
                        </v-tooltip>
                        <v-tooltip bottom max-width="320">
                            <template #activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="d-inline-block">
                                    <v-btn outlined :disabled="segmentationLoading" @click="openStatistics(activeBannerKey)">Посмотреть статистику</v-btn>
                                </span>
                            </template>
                            <span>{{ segmentationActionTooltips.viewAnalytics }}</span>
                        </v-tooltip>
                    </template>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="sg-client-sidebar-backdrop" v-if="clientSidebarOpen" @click="closeClientSidebar"></div>
        <div class="sidebar-spacer" v-if="clientSidebarOpen"></div>
        <v-navigation-drawer
            class="GCB2-sidebar subscribers-growth-client-drawer"
            :value="clientSidebarOpen"
            fixed
            right
            width="420px"
            :mobile-breakpoint="0"
            @input="onClientSidebarModelChange"
            @click.native.stop
        >
            <div class="sidebar-header-wrapper">
                <div class="sidebar-header pt-4">
                    <v-row class="ma-0" justify="space-between" align="center">
                        <div class="sidebar-client-headline pr-2">
                            <div class="sidebar-client-name">{{ activeClient.name }}</div>
                            <div class="sidebar-client-phone">{{ activeClient.phone }}</div>
                        </div>
                        <div class="d-flex align-center">
                            <v-btn icon small @click.stop="copyClientPhone"><v-icon small>mdi-content-copy</v-icon></v-btn>
                            <v-btn icon @click.stop="closeClientSidebar"><v-icon>mdi-close</v-icon></v-btn>
                        </div>
                    </v-row>
                </div>
            </div>
            <div class="sidebar-content">
                <v-expansion-panels v-if="clientSidebarItemStub" multiple class="mt-3">
                    <v-expansion-panel>
                        <v-expansion-panel-header class="expansion-panel-header">
                            <span class="expansion-panel-header-text bolder">Лента событий</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <CommentHistoryCard
                                :key="'feed-' + activeClient.clientId"
                                :active-sidebar-item="clientSidebarItemStub"
                                :update-feed-timestamp="clientSidebarFeedRefreshTs"
                            />
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="expansion-panel-header">
                            <div class="d-flex align-center">
                                <span class="expansion-panel-header-text bolder">История посещений</span>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <VisitHistoryCard :visit-history-data="clientVisits" :loading="clientVisitsLoading" />
                            <div v-if="clientVisitsError" class="error-state mt-2">
                                {{ clientVisitsError }}
                                <v-btn small text color="mainNew" @click="loadClientVisits">Попробовать снова</v-btn>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
import moment from 'moment'
import qs from 'qs'
import uniqueId from 'lodash/uniqueId'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import BaseInputOutlined from '@/components/inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '@/components/inputs/CustomActivatorSelect.vue'
import TimeLimitsSettings from '@/components/chisai/GCB2/changeActivation/TimeLimitsSettings.vue'
import MessageSettings from '@/components/chisai/GCB2/changeActivation/MessageSettings.vue'
import AudienceTitleWithParams from '@/components/chisai/GCB2/changeActivation/AudienceSettings/AudienceTitleWithParams.vue'
import SpinnerLoader from '@/components/SpinnerLoader.vue'
import CommentHistoryCard from '@/components/chisai/GCB2/clientInfo/CommentHistoryCard.vue'
import VisitHistoryCard from '@/components/chisai/GCB2/clientInfo/VisitHistoryCard.vue'
import { CONNECTOR_TYPES } from '@/vars/general'
import {
    AUDEINCE_ADDITIONAL_SETTINGS,
    CHANGE_ACTIVATION_TYPES,
    MESSAGING_CHANNELS_FLAT_LIST_KEY,
    SUBSCRIBERS_GROWTH_SYNTHETIC_AUDIENCE_IDS,
} from '@/vars/GCB2'
import { isBlank } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import mapValues from 'lodash/mapValues'
import omitBy from 'lodash/omitBy'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import uniq from 'lodash/uniq'
import { checkRole } from '@/helpers/roles'
import {
    createActivation,
    createMessage,
    createMessagePart,
    deleteMessagePart,
    getActivations,
    getActivationList,
    getAudience,
    getBotChannelList,
    getClientVisitsHistoryData,
    getClientYcCategoryList,
    getMaxBusinessChannels,
    getMaxBusinessChannelAnalytics,
    getMessage,
    getProductWithoutAbonementList,
    getServiceByCategoryList,
    getServiceCategoryList,
    getStaffList,
    getTagSubgroupList,
    toogleIsRunning,
    updateActivation,
    updateMessage,
    updateMessagePart,
} from '@/api/chisai/GCB2'
import { normalizeBotChannelList } from '@/components/chisai/GCB2/utils/botChannelList'
import {
    applySubscribersGrowthBotLinkPlaceholder,
    getInviteUnsubscribedDefaultScript,
    getSubscribersGrowthMaxBotTelegramLink,
    normalizeSubscribersGrowthBotLink,
    restoreSubscribersGrowthBotLinkPlaceholder,
    resolveSubscribersGrowthSendingChannelId,
    resolveSubscribersGrowthWidgetChannelId,
    SAFE_MAILING_SCRIPT_PLACEHOLDER,
    SUBSCRIBERS_GROWTH_BOT_LINK_PLACEHOLDER,
    SUBSCRIBERS_GROWTH_BOT_LINK_VAR,
} from '@/utils/subscribersGrowthWidget'
import { getMaxBusinessBotTelegramLink } from '@/api/networkFixer'
import { mapMaxBusinessChannelsToSelectOptions } from '@/utils/channelDisplayName'
import cfg from '@root/config'

const SEGMENTATION_FETCH_LIST_FUNCTIONS = {
    staff_list: getStaffList,
    service_list: getServiceByCategoryList,
    category_list: getServiceCategoryList,
    activation_list: getActivationList,
    tag_list: getTagSubgroupList,
    bot_channel_list: getBotChannelList,
    product_list: getProductWithoutAbonementList,
}

const defaultDates = ['2026-03-01', '2026-03-31']
const monthNames = ['янв', 'фев', 'март', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']
const fullMonthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']

/** Mock monthsDynamicsData for chart; enable via cfg.subscribersGrowthChartMock or ?chartMock=1 */
function getSubscribersGrowthChartMockMonthsDynamics(year) {
    const y = Number(year) || new Date().getFullYear()
    const yPrev = y - 1
    return [
        { month: 8, year: yPrev, subscribed: 0, unsubscribed: 0 },
        { month: 9, year: yPrev, subscribed: 1, unsubscribed: 0 },
        { month: 10, year: yPrev, subscribed: 0, unsubscribed: 1 },
        { month: 11, year: yPrev, subscribed: 3, unsubscribed: 1 },
        { month: 12, year: yPrev, subscribed: 2, unsubscribed: 2 },
        { month: 1, year: y, subscribed: 4, unsubscribed: 0 },
        { month: 2, year: y, subscribed: 1, unsubscribed: 3 },
        { month: 3, year: y, subscribed: 12, unsubscribed: 4 },
        { month: 4, year: y, subscribed: 1, unsubscribed: 2 },
        { month: 5, year: y, subscribed: 2, unsubscribed: 0 },
        { month: 6, year: y, subscribed: 0, unsubscribed: 0 },
    ]
}

const SEGMENT_GROUP = 'Прирост подписчиков'
const SEGMENT_TAG_PREFIX = 'subscribers_growth:'
const SEGMENTATION_SUBSCRIPTION_STATUS_FIELD = 'subgrowth_subscription_status'
const SEGMENTATION_AUDIENCE_CHANNEL_FIELD = 'subgrowth_send_channel_id'
const SEGMENTATION_LOCKED_AUDIENCE_FIELDS = Object.freeze([
    SEGMENTATION_SUBSCRIPTION_STATUS_FIELD,
    SEGMENTATION_AUDIENCE_CHANNEL_FIELD,
    'bot_channel',
])

function isTriStateSubscriptionSelect(item) {
    if (!item || item.type !== 'select' || !Array.isArray(item.customList)) return false
    const ids = new Set(item.customList.map((opt) => String(opt?.id || '')))
    return ids.has('subscribed') && ids.has('not_subscribed')
}

/** Подписка на канал (MAX и т.д.) как boolSelect: «подписан» / «не подписан». */
function isMaxSubscriptionBoolSelect(item) {
    if (!item || item.type !== 'boolSelect' || !item.valueField) return false
    const tt = String(item.trueText || '').toLowerCase()
    const ft = String(item.falseText || '').toLowerCase()
    return tt.includes('подпис') && ft.includes('подпис')
}

/** Все элементы схемы аудитории, включая вложенные `block_schema` (плоский schema.flat() их не видит). */
function collectAllAudienceSchemaItems(schema) {
    const out = []
    const visit = (item) => {
        if (!item || typeof item !== 'object') return
        out.push(item)
        if (Array.isArray(item.block_schema)) {
            item.block_schema.forEach(visit)
        }
        if (Array.isArray(item.content)) {
            item.content.forEach(visit)
        }
    }
    if (!Array.isArray(schema)) return out
    schema.forEach((part) => {
        if (Array.isArray(part)) {
            part.forEach(visit)
        } else {
            visit(part)
        }
    })
    return out
}

/** Клон аудитории с заблокированным полем статуса подписки (только для мастера в отчёте). */
function audienceWithLockedSubscriptionSchema(audience) {
    if (!audience) return null
    const cloned = cloneDeep(audience)
    const schema = cloned.settings?.schema
    if (!Array.isArray(schema) || !schema.length) return cloned
    const isSubscriptionStatusItem = (item) => {
        if (!item || typeof item !== 'object') return false
        if (item.valueField === SEGMENTATION_SUBSCRIPTION_STATUS_FIELD) return true
        return isTriStateSubscriptionSelect(item) || isMaxSubscriptionBoolSelect(item)
    }
    const isSubscriptionChannelItem = (item) => {
        if (!item || typeof item !== 'object') return false
        if (SEGMENTATION_LOCKED_AUDIENCE_FIELDS.includes(item.valueField)) return true
        return item.list === 'bot_channel_list'
    }
    const visit = (item) => {
        if (!item || typeof item !== 'object') return
        if (isSubscriptionStatusItem(item) || isSubscriptionChannelItem(item)) {
            item.disabled = true
        }
        if (Array.isArray(item.block_schema)) {
            item.block_schema.forEach(visit)
        }
        if (Array.isArray(item.content)) {
            item.content.forEach(visit)
        }
    }
    schema.forEach((part) => {
        if (!Array.isArray(part)) return
        part.forEach(visit)
    })
    return cloned
}

const LEGACY_SAFE_MAILING_DEFAULT_SCRIPT =
    'Здравствуйте! Для вас есть важная информация и персональные предложения в нашем MAX-боте.'

const SEGMENT_DEFINITIONS = [
    {
        key: 'invite_unsubscribed',
        title: 'Пригласить тех, кто не подписан',
        emoji: '📣',
        defaultActivationName: 'Пригласить тех, кто не подписан',
        defaultAudienceRule: 'Подписка на MAX: Не подписан',
        defaultScript: getInviteUnsubscribedDefaultScript(),
        channelMode: 'non_max',
    },
    {
        key: 'safe_mailing',
        title: 'Безопасная рассылка',
        emoji: '🛡️',
        defaultActivationName: 'Безопасная рассылка',
        defaultAudienceRule: 'Подписка на MAX: Подписан',
        defaultScript: '',
        channelMode: 'max_only',
    },
]

export default {
    name: 'SubscribersGrowthReportView',
    components: {
        Breadcrumbs,
        BaseInputOutlined,
        CustomActivatorSelect,
        TimeLimitsSettings,
        MessageSettings,
        AudienceTitleWithParams,
        SpinnerLoader,
        CommentHistoryCard,
        VisitHistoryCard,
    },
    data: () => ({
        loading: false,
        dateMenu: false,
        periodDates: [...defaultDates],
        tablePage: 1,
        itemsPerPage: 10,
        filters: { channel: '', status: 'all' },
        chartFilter: null,
        chartMode: 'both',
        chartModeOptions: [
            { id: 'both', name: 'Подписки и отписки' },
            { id: 'subs', name: 'Только подписки' },
            { id: 'unsubs', name: 'Только отписки' },
        ],
        maxBusinessChannelsRaw: [],
        statusOptions: [
            { id: 'all', name: 'Все' },
            { id: 'true', name: 'Подписан' },
            { id: 'false', name: 'Отписался' },
        ],
        headers: [
            { text: 'Клиент', value: 'name', sortable: true },
            { text: 'Статус подписки', value: 'status', sortable: true },
            { text: 'Дата подписки на бота', value: 'subscribedAt', sortable: true },
            { text: 'Дата отписки от бота', value: 'unsubscribedAt', sortable: true },
        ],
        rows: [],
        monthStats: [],
        allClientsCount: 0,
        botRegisteredFiltered: 0,
        botRegisteredSubscribed: 0,
        botRegisteredFilteredPercent: 0,
        botRegisteredSubscribedPercent: 0,
        segmentationDialog: false,
        segmentationLoading: false,
        segmentationStartDateMenu: false,
        segmentationEndDateMenu: false,
        activeBannerKey: null,
        clientSidebarOpen: false,
        activeClient: { clientId: '', name: '', phone: '' },
        clientSidebarFeedRefreshTs: 0,
        clientVisits: [],
        clientVisitsLoading: false,
        clientVisitsError: '',
        segmentationForm: {
            name: '',
            channel: '',
            intervalFrom: '12:00',
            intervalTo: '17:00',
            timeZone: '3',
            messagesInBatch: 1,
            messagesPerDay: 20,
            minutesBetween: 5,
            startDate: '',
            endDate: '',
        },
        segmentationActivationDraft: {
            audienceId: null,
            extra: {
                filter: {},
                automail: {
                    sendAfter: '12:00',
                    sendBefore: '17:00',
                    timezoneOffset: 3,
                },
            },
            message: {
                messageParts: [
                    { partNumber: 1, textVariant: '', _id: 'seg-1' },
                ],
            },
        },
        segmentationAutomailValidate: {
            isAutomail: true,
            isValidScripts: true,
            isSaveButtonClicked: false,
        },
        segmentsByBanner: {
            invite_unsubscribed: null,
            safe_mailing: null,
        },
        segmentationAudienceList: [],
        segmentationAudienceLists: {},
        segmentationAudienceFilterValues: {},
        segmentationAudiencesLoading: false,
        segmentationAudiencesFetched: false,
        /** Синтетическая аудитория со схемой сценария 7; при открытии мастера перезаписывается */
        segmentationDialogAudience: null,
        segmentationBotTelegramLink: '',
        segmentationActionTooltips: {
            startNow: '«Сегментация будет сохранена и авторассылка по ней начнётся согласно параметрам, указанным справа»',
            saveWithoutStart: '«Сегментация будет сохранена, авторассылка не запустится. Запустить можно будет позже через кнопку "Редактировать сегментацию"»',
            saveWhileRunning: '«Изменения будут сохранены, авторассылка продолжит работу»',
            stopSending: '«Авторассылка будет остановлена, изменения сохранены»',
            viewAnalytics: '«Откроется страница аналитики по данной активации в новой вкладке»',
        },
    }),
    computed: {
        project() { return this.$store.getters.projectById(this.$route.params.id) },
        projectId() { return this.$route.params.id },
        isHrProject() {
            return this.project?.connectors?.find((con) => con.connectorType === 'GCB2')?.hrProject || false
        },
        breadcrumbs() {
            return [
                { text: this.project && this.project.name ? this.project.name : '', to: `/project/${this.$route.params.id}` },
                { text: '👉 Прирост подписчиков', to: '', disabled: true },
            ]
        },
        filteredRows() {
            if (this.filters.status === 'all') return this.rows
            return this.rows.filter((row) => (this.filters.status === 'true' ? row.status === 'Подписан' : row.status === 'Отписался'))
        },
        showPeriodFilter() {
            return this.filters.status !== 'all'
        },
        periodFilterLabel() {
            if (this.filters.status === 'true') return 'Период подписки'
            if (this.filters.status === 'false') return 'Период отписки'
            return 'Период'
        },
        periodLabel() {
            if (this.chartFilter) return `с ${moment(this.chartFilter.dateFrom).format('DD.MM.YYYY')} по ${moment(this.chartFilter.dateTo).format('DD.MM.YYYY')}`
            if (!this.showPeriodFilter) return 'За весь период'
            if (!this.periodDates || this.periodDates.length < 2) return 'с [     ] по [     ]'
            const sorted = [...this.periodDates].sort()
            return `с ${moment(sorted[0]).format('DD.MM.YYYY')} по ${moment(sorted[1]).format('DD.MM.YYYY')}`
        },
        tableFooterProps() {
            return { 'items-per-page-options': [10, 15, 25, -1] }
        },
        /** Уникальные целые отметки 0…max; позиция по доле значения (без дублей при малых max). */
        chartScaleTicks() {
            const scaleMax = Math.max(Number(this.chartScaleMax) || 0, 1)
            const m = Math.max(Math.round(scaleMax), 1)
            const slotCount = 5
            const raw = []
            for (let i = 0; i < slotCount; i++) {
                raw.push(Math.round((m * (slotCount - 1 - i)) / (slotCount - 1)))
            }
            const ordered = []
            const seen = new Set()
            for (const v of raw) {
                if (!seen.has(v)) {
                    ordered.push(v)
                    seen.add(v)
                }
            }
            if (!seen.has(0)) {
                ordered.push(0)
            }
            const values = [...new Set(ordered)].sort((a, b) => b - a)
            return values.map((value) => ({
                value,
                label: String(value),
                topPercent: scaleMax > 0 ? (1 - value / scaleMax) * 100 : 0,
            }))
        },
        chartScaleMax() {
            const values = this.monthStats.flatMap((month) => {
                const monthValues = []
                if (this.showSubsBar) monthValues.push(Number(month.subs) || 0)
                if (this.showUnsubsBar) monthValues.push(Number(month.unsubs) || 0)
                return monthValues
            })
            const maxValue = values.length ? Math.max(...values) : 0
            return Math.max(maxValue, 1)
        },
        segmentBanners() {
            return SEGMENT_DEFINITIONS.map((segment) => ({
                ...segment,
                segment: this.segmentsByBanner[segment.key],
            }))
        },
        activeBannerTitle() {
            return this.segmentBanners.find((item) => item.key === this.activeBannerKey)?.title || 'Сегментация'
        },
        segmentationDialogTitle() {
            return `Мастер сегментации — ${this.activeBannerTitle}`
        },
        isActiveSegmentRunning() {
            if (!this.activeBannerKey) return false
            return Boolean(this.segmentsByBanner[this.activeBannerKey]?.isRunning)
        },
        showSubsBar() {
            return ['both', 'subs'].includes(this.chartMode)
        },
        showUnsubsBar() {
            return ['both', 'unsubs'].includes(this.chartMode)
        },
        showMissingChannelsBanner() {
            const connectors = this.project?.connectors || []
            const hasMaxBusiness = connectors.some((con) => {
                const channelType = con?.channelType || ''
                const providerType = con?.providerType || ''
                return channelType === 'maxBusiness' || ['maxBusiness', 'maxBasis'].includes(providerType)
            })
            const hasWhatsapp = connectors.some((con) => {
                const channelType = con?.channelType || ''
                const providerType = con?.providerType || ''
                return channelType === 'whatsappChannel' || ['whatsappBasis', 'whatsappApi', 'whatsapp', 'dh-whatsapp'].includes(providerType)
            })
            const hasTelegram = connectors.some((con) => {
                const channelType = con?.channelType || ''
                const providerType = con?.providerType || ''
                return channelType === 'telegramChannel' || ['telegramApi', 'telegramDh'].includes(providerType)
            })
            return hasMaxBusiness && !hasWhatsapp && !hasTelegram
        },
        canEditSegmentation() {
            const rs = this.project?.rolesSettings
            if (rs && rs['gcb2:subscribersGrowth:edit']) {
                return checkRole(this.projectId, 'gcb2:subscribersGrowth:edit')
            }
            return checkRole(this.projectId, 'gcb2:activation:edit')
        },
        segmentationDefinition() {
            return SEGMENT_DEFINITIONS.find((segment) => segment.key === this.activeBannerKey) || null
        },
        segmentationAudienceRuleLabel() {
            return this.segmentationDefinition?.defaultAudienceRule || 'Подписка на MAX'
        },
        segmentationAudienceEditMode() {
            return CHANGE_ACTIVATION_TYPES.edit
        },
        segmentationMassEditActivationStub() {
            return { name: this.segmentationForm.name || '', projectId: this.projectId }
        },
        segmentationAudienceTemplate() {
            if (this.segmentationDialogAudience) return this.segmentationDialogAudience
            const list = this.segmentationAudienceList || []
            const byAudienceId = this.activeBannerKey
                ? list.find((aud) => Number(aud?.id) === Number(SUBSCRIBERS_GROWTH_SYNTHETIC_AUDIENCE_IDS[this.activeBannerKey]))
                : null
            if (byAudienceId) return byAudienceId
            const rule = this.segmentationDefinition?.defaultAudienceRule
            if (!rule) return null
            const exact = list.find((a) => a && a.settings && a.settings.rule === rule)
            if (exact) return exact
            const fragment = rule.split(':')[0].trim()
            return list.find((a) => typeof a?.name === 'string' && a.name.includes(fragment)) || null
        },
        segmentationAudienceTemplateForMaster() {
            return audienceWithLockedSubscriptionSchema(this.segmentationAudienceTemplate)
        },
        segmentationAudienceHasSchema() {
            const a = this.segmentationAudienceTemplate
            if (!a || !a.settings) return false
            const { schema, additional_params_list: addl } = a.settings
            if (Array.isArray(schema) && schema.length) return true
            if (Array.isArray(addl) && addl.length) return true
            return false
        },
        yClientsConnector() {
            return this.project?.connectors?.find((el) => el.connectorType === CONNECTOR_TYPES.yClients) || null
        },
        channelOptions() {
            return mapMaxBusinessChannelsToSelectOptions(
                this.maxBusinessChannelsRaw,
                this.project?.connectors || []
            )
        },
        allMessagingChannels() {
            const connectors = this.project?.connectors || []
            return connectors
                .map((con, idx) => {
                    const channelType = con?.channelType || ''
                    const providerType = con?.providerType || ''
                    let name = null
                    if (channelType === 'whatsappChannel' || ['whatsappBasis', 'whatsappApi', 'whatsapp', 'dh-whatsapp'].includes(providerType)) {
                        name = 'WhatsApp'
                    } else if (channelType === 'telegramChannel' || ['telegramApi', 'telegramDh'].includes(providerType)) {
                        name = 'Telegram'
                    } else if (channelType === 'maxBusiness' || ['maxBusiness', 'maxBasis'].includes(providerType)) {
                        name = 'MAX Business'
                    }
                    if (!name) return null
                    return {
                        id: String(con?.connectorId || con?.id || `${name}-${idx}`),
                        name,
                        channelType,
                        providerType,
                    }
                })
                .filter(Boolean)
        },
        segmentationChannelOptions() {
            const mode = this.segmentationDefinition?.channelMode
            if (mode === 'max_only') {
                return this.allMessagingChannels.filter((channel) => channel.name === 'MAX Business')
            }
            if (mode === 'non_max') {
                return this.allMessagingChannels.filter((channel) => channel.name !== 'MAX Business')
            }
            return this.allMessagingChannels
        },
        segmentationScriptPlaceholder() {
            if (this.activeBannerKey === 'safe_mailing') return SAFE_MAILING_SCRIPT_PLACEHOLDER
            return ''
        },
        segmentationExtraMessageVars() {
            if (this.activeBannerKey !== 'invite_unsubscribed') return []
            return [
                {
                    id: SUBSCRIBERS_GROWTH_BOT_LINK_VAR,
                    name: SUBSCRIBERS_GROWTH_BOT_LINK_VAR,
                },
            ]
        },
        segmentationPreviewTextTransform() {
            if (this.activeBannerKey !== 'invite_unsubscribed') return null
            const link = this.segmentationBotTelegramLink
            return (text) => applySubscribersGrowthBotLinkPlaceholder(text, link)
        },
        segmentationScriptText() {
            const firstPart = this.segmentationActivationDraft?.message?.messageParts?.find((part) => !part._deleted) || null
            return String(firstPart?.textVariant || '').trim()
        },
        isSafeMailingScriptUnset() {
            if (this.activeBannerKey !== 'safe_mailing') return false
            const script = this.segmentationScriptText
            if (!script) return true
            if (script === SAFE_MAILING_SCRIPT_PLACEHOLDER) return true
            if (script === LEGACY_SAFE_MAILING_DEFAULT_SCRIPT) return true
            return false
        },
        canSubmitSegmentation() {
            return Boolean(
                this.segmentationForm.name &&
                this.segmentationForm.channel &&
                this.segmentationScriptText.length > 2 &&
                !this.isSafeMailingScriptUnset
            )
        },
        canLaunchSegmentation() {
            return this.canSubmitSegmentation
        },
        segmentationStartNowTooltip() {
            if (this.activeBannerKey === 'safe_mailing' && this.isSafeMailingScriptUnset) {
                return SAFE_MAILING_SCRIPT_PLACEHOLDER
            }
            return this.segmentationActionTooltips.startNow
        },
        showSegmentationIntervalWarning() {
            const toMinutes = (timeStr) => {
                if (!timeStr || typeof timeStr !== 'string') return null
                const [h, m] = timeStr.split(':').map(Number)
                if (Number.isNaN(h) || Number.isNaN(m)) return null
                return h * 60 + m
            }
            const after = toMinutes(this.segmentationActivationDraft?.extra?.automail?.sendAfter)
            const before = toMinutes(this.segmentationActivationDraft?.extra?.automail?.sendBefore)
            if (after === null || before === null) return false
            return before <= after
        },
        summaryTitle() {
            if (this.filters.status === 'true') return 'Сейчас активны'
            if (this.filters.status === 'false') return 'Были, но ушли'
            return 'Когда-либо запускали бота'
        },
        summaryPercent() {
            if (!this.allClientsCount) return 0
            return Math.round((this.filteredRows.length / this.allClientsCount) * 100)
        },
        chartFilterText() {
            if (!this.chartFilter) return ''
            const action = this.chartFilter?.type === 'true' ? 'подписавшиеся' : 'отписавшиеся'
            return `Фильтр с графика: ${action} за ${this.chartFilter?.label || ''}`
        },
        /** Минимальный объект для CommentHistoryCard (как в основном сайдбаре tasklist) */
        clientSidebarItemStub() {
            if (!this.clientSidebarOpen || !this.activeClient.clientId) {
                return null
            }
            return { clientId: this.activeClient.clientId }
        },
    },
    async created() {
        await this.loadChannelsAndInitialReport()
        await this.loadSegments()
    },
    watch: {
        'filters.status'(status) {
            if (status === 'all') this.dateMenu = false
            this.tablePage = 1
        },
        clientSidebarOpen(opened) {
            if (opened) {
                this.addMarginToContent()
                this.addMarginToBreadcrumbs()
            } else {
                this.removeMarginFromContent()
                this.removeMarginFromBreadcrumbs()
            }
        },
        projectId() {
            this.segmentationAudiencesFetched = false
            this.segmentationAudienceList = []
            this.segmentationAudienceLists = {}
            this.segmentationAudienceFilterValues = {}
            this.segmentationDialogAudience = null
        },
        segmentationAudienceFilterValues: {
            deep: true,
            handler() {
                this.syncSegmentationAudienceFilterToExtra()
            },
        },
        'segmentationForm.channel'(v) {
            if (this.activeBannerKey === 'invite_unsubscribed') return
            const tmpl = this.segmentationAudienceTemplate
            if (!tmpl || !this.segmentationAudienceHasSchema || !this.segmentationAudienceFilterValues[tmpl.id]) return
            if (this.segmentationAudienceFilterValues[tmpl.id].subgrowth_send_channel_id === v) return
            this.$set(this.segmentationAudienceFilterValues[tmpl.id], 'subgrowth_send_channel_id', v)
        },
        '$route.query.botChannel'() {
            this.loadChannelsAndInitialReport()
        },
        'filters.channel': {
            async handler() {
                if (!this.segmentationDialog || this.activeBannerKey !== 'invite_unsubscribed') return
                this.segmentationBotTelegramLink = await this.resolveWidgetMaxBotTelegramLink()
            },
        },
    },
    methods: {
        onClientSidebarModelChange(value) {
            if (!value) {
                this.closeClientSidebar()
            }
        },
        closeClientSidebar() {
            this.clientSidebarOpen = false
        },
        addMarginToContent() {
            const contentWrapper = document.getElementsByClassName('content-wrapper')[0]
            const content = contentWrapper?.getElementsByClassName('content')[0]
            if (content) {
                content.classList.add('sidebar-is-open')
            }
        },
        removeMarginFromContent() {
            const contentWrapper = document.getElementsByClassName('content-wrapper')[0]
            const content = contentWrapper?.getElementsByClassName('content')[0]
            if (content) {
                content.classList.remove('sidebar-is-open')
            }
        },
        addMarginToBreadcrumbs() {
            const contentWrapper = document.getElementsByClassName('breadcrumbs-wrapper')[0]
            const content = contentWrapper?.getElementsByClassName('breadcrumbs')[0]
            if (contentWrapper) {
                contentWrapper.classList.add('sidebar-is-open')
            }
            if (content) {
                content.classList.add('sidebar-is-open')
            }
        },
        removeMarginFromBreadcrumbs() {
            const contentWrapper = document.getElementsByClassName('breadcrumbs-wrapper')[0]
            const content = contentWrapper?.getElementsByClassName('breadcrumbs')[0]
            if (contentWrapper) {
                contentWrapper.classList.remove('sidebar-is-open')
            }
            if (content) {
                content.classList.remove('sidebar-is-open')
            }
        },
        applySubscribersGrowthFiltersFromNavigation() {
            this.filters.status = 'all'
            this.chartFilter = null
            this.chartMode = 'both'
            this.periodDates = [...defaultDates]
            this.tablePage = 1
            this.dateMenu = false
        },
        async loadChannelsAndInitialReport() {
            this.loading = true
            try {
                const { data, error } = await getMaxBusinessChannels({ projectId: this.projectId })
                if (error) throw new Error(error.message || 'Не удалось загрузить каналы')

                this.maxBusinessChannelsRaw = data || []

                const presetRaw = this.$route.query.botChannel
                const presetSingle = Array.isArray(presetRaw) ? presetRaw[0] : presetRaw
                const preset =
                    presetSingle !== undefined && presetSingle !== null && String(presetSingle).length > 0
                        ? String(presetSingle)
                        : null

                if (preset) {
                    this.applySubscribersGrowthFiltersFromNavigation()
                    const presetOk = this.channelOptions.some((o) => String(o.id) === preset)
                    if (presetOk) {
                        this.filters.channel = preset
                    } else if (this.channelOptions.length > 0) {
                        this.filters.channel = this.channelOptions[0].id
                    } else {
                        this.filters.channel = ''
                    }
                } else if (this.channelOptions.length > 0 && !this.filters.channel) {
                    this.filters.channel = this.channelOptions[0].id
                }

                if (this.filters.channel) {
                    await this.loadReport()
                }
            } catch (e) {
                this.$store.dispatch('callNotify', e.message || 'Ошибка при загрузке каналов')
            } finally {
                this.loading = false
            }
        },
        async loadSegments() {
            try {
                const { data, error } = await getActivations(this.projectId, this.isHrProject)
                if (error) throw new Error(error.message || 'Не удалось загрузить сегменты')
                const nextSegments = { invite_unsubscribed: null, safe_mailing: null }
                for (const activation of data || []) {
                    const tags = activation.tags || []
                    const segmentKeyTag = tags.find((tag) => typeof tag === 'string' && tag.startsWith(SEGMENT_TAG_PREFIX))
                    const segmentKeyFromTag = segmentKeyTag ? segmentKeyTag.replace(SEGMENT_TAG_PREFIX, '') : null
                    const segmentKeyFromName = SEGMENT_DEFINITIONS.find((segment) => segment.title === activation.name)?.key || null
                    const segmentKey = segmentKeyFromTag || segmentKeyFromName
                    if (!segmentKey || !Object.prototype.hasOwnProperty.call(nextSegments, segmentKey)) continue
                    nextSegments[segmentKey] = {
                        id: activation.id,
                        isRunning: Boolean(activation.isRunning),
                        name: activation.name,
                        messageId: activation.messageId,
                        audienceId: activation.audienceId,
                        extra: activation.extra || {},
                    }
                }
                this.segmentsByBanner = nextSegments
            } catch (e) {
                this.$store.dispatch('callNotify', e.message || 'Ошибка загрузки сегментации')
            }
        },
        toApiFilters() {
            const filters = {
                botChannel: this.filters.channel,
                subscribeStatus: this.chartFilter ? this.chartFilter.type : this.filters.status,
                filialList: [],
            }
            if (this.chartFilter) {
                filters.dateFrom = this.chartFilter.dateFrom
                filters.dateTo = this.chartFilter.dateTo
            } else if (this.filters.status !== 'all') {
                const sorted = [...this.periodDates].sort()
                filters.dateFrom = sorted[0] || defaultDates[0]
                filters.dateTo = sorted[1] || sorted[0] || defaultDates[1]
            }
            return filters
        },
        async loadReport() {
            const outputList = {
                dateFrom: true,
                dateTo: true,
                registeredStatistic: true,
                clientTableData: true,
                monthsDynamicsData: true,
                filialList: false,
            }
            const { data, error } = await getMaxBusinessChannelAnalytics({
                projectId: this.projectId,
                filters: this.toApiFilters(),
                outputList,
            })
            if (error) throw new Error(error.message || 'Не удалось загрузить отчет')

            const report = data || {}
            const useChartMock =
                Boolean(cfg.subscribersGrowthChartMock) || String(this.$route.query.chartMock || '') === '1'
            const monthsDynamicsSource = useChartMock
                ? getSubscribersGrowthChartMockMonthsDynamics(moment().year())
                : report.monthsDynamicsData || []

            this.rows = (report.clientTableData || []).map((row) => {
                const phone = row.clientPhone || '—'
                return {
                    clientId: String(row.clientId || row.client_id || '').trim(),
                    phone,
                    name: `${row.clientName || 'Клиент'} / ${phone}`,
                    status: row.subscribeStatus || '—',
                    subscribedAt: row.subscribedAt && row.subscribedAt !== '—' ? moment(row.subscribedAt).format('DD.MM.YYYY') : '—',
                    unsubscribedAt: row.unsubscribedAt && row.unsubscribedAt !== '—' ? moment(row.unsubscribedAt).format('DD.MM.YYYY') : '—',
                }
            })

            const apiMonthStats = (monthsDynamicsSource || []).map((m) => {
                const monthIndex = Math.max(1, Number(m.month || 1)) - 1
                const short = monthNames[monthIndex] || `${m.month}`
                const full = fullMonthNames[monthIndex] || `Месяц ${m.month}`
                return {
                    name: short,
                    short,
                    month: Number(m.month || 1),
                    year: Number(m.year || moment().year()),
                    periodLabel: `${full} ${m.year}`,
                    subs: Number(m.subscribed || 0),
                    unsubs: Number(m.unsubscribed || 0),
                }
            })
            this.monthStats = apiMonthStats

            this.allClientsCount = Number(report.allClientsCount || 0)
            this.botRegisteredFiltered = Number(report.botRegisteredFiltered || 0)
            this.botRegisteredSubscribed = Number(report.botRegisteredSubscribed || 0)
            this.botRegisteredFilteredPercent = Number(report.botRegisteredFilteredPercent || 0)
            this.botRegisteredSubscribedPercent = Number(report.botRegisteredSubscribedPercent || 0)
            this.tablePage = 1
        },
        barHeightPercent(value) {
            const n = Number(value) || 0
            return Math.min((n / this.chartScaleMax) * 100, 100)
        },
        onDateChange() {},
        formatDateForInput(value) {
            if (!value) return ''
            return moment(value).format('DD.MM.YYYY')
        },
        async ensureSegmentationAudiencesLoaded() {
            if (this.segmentationAudiencesFetched) return
            this.segmentationAudiencesLoading = true
            try {
                const data = await getAudience(this.projectId, this.isHrProject)
                if (data && data.error) {
                    this.$store.dispatch('callNotify', String(data.error.message || 'Не удалось загрузить аудитории'))
                    this.segmentationAudienceList = []
                } else {
                    this.segmentationAudienceList = Object.freeze(Array.isArray(data) ? data : [])
                    this.segmentationAudiencesFetched = true
                }
            } finally {
                this.segmentationAudiencesLoading = false
            }
        },
        async fetchSegmentationAudienceLists() {
            const tmpl = this.segmentationAudienceTemplate
            const nextLists = {}
            if (!tmpl?.settings?.schema) {
                this.segmentationAudienceLists = nextLists
                return
            }
            const listsToFetch = uniq(
                tmpl.settings.schema
                    .flat()
                    .filter((el) => el && el.type === 'select' && el.list)
                    .map((el) => el.list)
            )
            await Promise.all(
                listsToFetch.map(async (listName) => {
                    if (listName === MESSAGING_CHANNELS_FLAT_LIST_KEY) {
                        nextLists[listName] = Object.freeze(
                            (this.allMessagingChannels || []).map((c) => ({ id: c.id, name: c.name }))
                        )
                        return
                    }
                    const fetchFn = SEGMENTATION_FETCH_LIST_FUNCTIONS[listName]
                    if (!fetchFn) return
                    const res = await fetchFn({ projectId: this.projectId })
                    const payload = res && res.error ? [] : res && res.data !== undefined ? res.data : res
                    const rawList = Array.isArray(payload) ? payload : []
                    nextLists[listName] = Object.freeze(
                        listName === 'bot_channel_list'
                            ? normalizeBotChannelList(rawList, this.project?.connectors || [])
                            : rawList
                    )
                })
            )
            if (this.yClientsConnector) {
                const res = await getClientYcCategoryList({ projectId: this.projectId })
                const payload = res && res.error ? [] : res && res.data !== undefined ? res.data : res
                nextLists.client_category_list = Object.freeze(Array.isArray(payload) ? payload : [])
            }
            if (this.isHrProject) {
                const pseudo = this.$store.getters.pseudoNetworkProjects || []
                nextLists.filial_list = pseudo.filter((el) => !el.isMain)
                nextLists.specialization_list = ['X9FUHP3L5', 'XSTM8F6WE'].includes(this.projectId)
                    ? [
                          { name: 'Ногтевой мастер', id: 'Ногтевой мастер' },
                          { name: 'Бровист/лашмейкер', id: 'Бровист/лашмейкер' },
                          { name: 'Массажист', id: 'Массажист' },
                          { name: 'Визажист-стилист/Парикмахер', id: 'Визажист-стилист/Парикмахер' },
                          { name: 'Мастер эпиляции', id: 'Мастер эпиляции' },
                          { name: 'Администратор', id: 'Администратор' },
                          { name: 'Управляющий', id: 'Управляющий' },
                          { name: 'Собственник', id: 'Собственник' },
                      ]
                    : [
                          { name: 'Администратор', id: 'Администратор' },
                          { name: 'Косметолог', id: 'Косметолог' },
                          { name: 'Мастер маникюра', id: 'Мастер маникюра' },
                          { name: 'Парикмахер', id: 'Парикмахер' },
                          { name: 'Другое', id: 'Другое' },
                      ]
            }
            this.segmentationAudienceLists = nextLists
        },
        initSegmentationAudienceFilterValues(currentSegment) {
            const tmpl = this.segmentationAudienceTemplate
            this.segmentationAudienceFilterValues = {}
            if (!tmpl || !this.segmentationAudienceHasSchema) return
            const filterValue = {}
            const schema = tmpl.settings?.schema || []
            const additionalParamsList = tmpl.settings?.additional_params_list
            const allSchemaItems = collectAllAudienceSchemaItems(schema)
            const subscriptionStatusValueFields = uniq(
                allSchemaItems
                    .filter((x) => x && x.valueField && (x.valueField === SEGMENTATION_SUBSCRIPTION_STATUS_FIELD || isTriStateSubscriptionSelect(x)))
                    .map((x) => x.valueField)
            )
            const maxSubscriptionBoolValueFields = uniq(
                allSchemaItems.filter((x) => x && x.valueField && isMaxSubscriptionBoolSelect(x)).map((x) => x.valueField)
            )

            const applyDefaultsFromItem = (schemaItem) => {
                if (!schemaItem) return
                if (schemaItem.valueField) {
                    let def = schemaItem.defaultValue
                    if (def === undefined && schemaItem.multiple) def = []
                    filterValue[schemaItem.valueField] = def
                }
                if (Array.isArray(schemaItem.block_schema)) {
                    schemaItem.block_schema.forEach(applyDefaultsFromItem)
                }
                if (Array.isArray(schemaItem.content)) {
                    schemaItem.content.forEach(applyDefaultsFromItem)
                }
            }
            if (schema.length) {
                schema.flat().forEach((el) => applyDefaultsFromItem(el))
            }
            if (additionalParamsList) {
                additionalParamsList.forEach((param) => {
                    const defautValue = get(AUDEINCE_ADDITIONAL_SETTINGS, `${param}.defaultValue`)
                    filterValue[param] = defautValue
                })
            }
            const saved = currentSegment?.extra?.filter || {}
            Object.assign(filterValue, saved)
            const forcedSubscriptionStatus = this.activeBannerKey === 'safe_mailing' ? 'subscribed' : 'not_subscribed'
            subscriptionStatusValueFields.forEach((vf) => {
                filterValue[vf] = forcedSubscriptionStatus
            })
            filterValue[SEGMENTATION_SUBSCRIPTION_STATUS_FIELD] = forcedSubscriptionStatus
            const forcedMaxSubscribedBool = this.activeBannerKey === 'safe_mailing'
            maxSubscriptionBoolValueFields.forEach((vf) => {
                filterValue[vf] = forcedMaxSubscribedBool
            })
            const maxChannel = (this.allMessagingChannels || []).find((ch) => ch && ch.name === 'MAX Business')
            const actualMaxChannelId = maxChannel && maxChannel.id !== undefined && maxChannel.id !== null && maxChannel.id !== ''
                ? String(maxChannel.id)
                : ''
            const botChannelField = allSchemaItems.find((x) => x && x.type === 'select' && x.list === 'bot_channel_list')?.valueField
            const botChannelList = this.segmentationAudienceLists?.bot_channel_list || []
            const projectConnectorIds = new Set(
                (this.project?.connectors || [])
                    .map((con) => String(con?.connectorId || con?.id || '').trim())
                    .filter(Boolean)
            )
            const resolveActualMaxBotChannelId = () => {
                if (!Array.isArray(botChannelList) || !botChannelList.length) return ''
                const maxItems = botChannelList.filter((it) =>
                    typeof it?.name === 'string' && it.name.toLowerCase().includes('max')
                )
                if (!maxItems.length) return ''
                const linkedToProjectConnector = maxItems.find((it) => {
                    const id = String(it?.id || '').trim()
                    const botConnectorId = String(it?.botConnectorId || '').trim()
                    return (id && projectConnectorIds.has(id)) || (botConnectorId && projectConnectorIds.has(botConnectorId))
                })
                if (linkedToProjectConnector?.id !== undefined && linkedToProjectConnector?.id !== null && linkedToProjectConnector?.id !== '') {
                    return String(linkedToProjectConnector.id)
                }
                const byCurrentConnectorId = actualMaxChannelId
                    ? maxItems.find((it) => String(it?.id || '') === actualMaxChannelId || String(it?.botConnectorId || '') === actualMaxChannelId)
                    : null
                if (byCurrentConnectorId?.id !== undefined && byCurrentConnectorId?.id !== null && byCurrentConnectorId?.id !== '') {
                    return String(byCurrentConnectorId.id)
                }
                const firstMax = maxItems.find((it) => it && it.id !== undefined && it.id !== null && it.id !== '')
                return firstMax ? String(firstMax.id) : ''
            }
            const actualMaxBotChannelId = resolveActualMaxBotChannelId()
            if (botChannelField && Array.isArray(botChannelList) && botChannelList.length) {
                const hasSavedBotChannel = saved[botChannelField] !== undefined && saved[botChannelField] !== null && saved[botChannelField] !== ''
                const currentBotChannel = filterValue[botChannelField]
                const isNeedDefaultBotChannel = !hasSavedBotChannel || currentBotChannel === 'maxBusiness'
                if (isNeedDefaultBotChannel) {
                    if (actualMaxBotChannelId) {
                        filterValue[botChannelField] = actualMaxBotChannelId
                    } else {
                        const maxItem = botChannelList.find((it) => typeof it?.name === 'string' && it.name.toLowerCase().includes('max'))
                        if (maxItem && maxItem.id !== undefined && maxItem.id !== null && maxItem.id !== '') {
                            filterValue[botChannelField] = String(maxItem.id)
                        }
                    }
                }
                if (this.activeBannerKey === 'safe_mailing' && actualMaxBotChannelId) {
                    filterValue[botChannelField] = actualMaxBotChannelId
                }
                if (actualMaxBotChannelId && this.activeBannerKey === 'invite_unsubscribed') {
                    filterValue[botChannelField] = actualMaxBotChannelId
                }
            }
            if (actualMaxChannelId) {
                filterValue.subgrowth_send_channel_id = actualMaxChannelId
            }
            this.$set(this.segmentationAudienceFilterValues, tmpl.id, filterValue)
            this.syncSegmentationAudienceFilterToExtra()
            const ch = filterValue.subgrowth_send_channel_id
            if (ch && this.activeBannerKey !== 'invite_unsubscribed') {
                this.segmentationForm.channel = ch
            }
        },
        syncSegmentationAudienceFilterToExtra() {
            const tmpl = this.segmentationAudienceTemplate
            if (!tmpl || !this.segmentationAudienceHasSchema) return
            const raw = this.segmentationAudienceFilterValues[tmpl.id]
            if (!raw) return
            const val = mapValues(raw, (o) => (isBlank(o) ? null : o))
            const filter = isEmpty(val) ? {} : omitBy(val, isNil)
            if (!this.segmentationActivationDraft.extra) {
                this.$set(this.segmentationActivationDraft, 'extra', {})
            }
            this.$set(this.segmentationActivationDraft.extra, 'filter', filter)
            const ch = filter.subgrowth_send_channel_id
            if (this.activeBannerKey !== 'invite_unsubscribed' && ch !== undefined && ch !== null && ch !== '') {
                this.segmentationForm.channel = ch
            }
        },
        normalizeAutomailTimezoneOffset(raw) {
            const n = Number(raw)
            if (raw !== undefined && raw !== null && raw !== '' && !Number.isNaN(n)) return n
            return 3
        },
        resolveSegmentationAudienceRule(segmentDefinition) {
            const fromBanner =
                this.activeBannerKey === 'safe_mailing'
                    ? 'subscribed'
                    : this.activeBannerKey === 'invite_unsubscribed'
                        ? 'not_subscribed'
                        : null
            if (fromBanner === 'subscribed') return 'Подписка на MAX: Подписан'
            if (fromBanner === 'not_subscribed') return 'Подписка на MAX: Не подписан'
            const f = this.segmentationActivationDraft?.extra?.filter
            if (!f || f.subgrowth_subscription_status == null || f.subgrowth_subscription_status === '') {
                return segmentDefinition.defaultAudienceRule
            }
            const s = f.subgrowth_subscription_status
            if (s === 'subscribed') return 'Подписка на MAX: Подписан'
            if (s === 'not_subscribed') return 'Подписка на MAX: Не подписан'
            if (s === 'any') return segmentDefinition.defaultAudienceRule
            return segmentDefinition.defaultAudienceRule
        },
        resolveSegmentationSendChannelId() {
            if (this.segmentationForm.channel !== undefined && this.segmentationForm.channel !== null && this.segmentationForm.channel !== '') {
                return this.segmentationForm.channel
            }
            return this.segmentationActivationDraft?.extra?.filter?.subgrowth_send_channel_id || ''
        },
        buildSegmentationSchemaAudience(bannerKey) {
            const audienceId = SUBSCRIBERS_GROWTH_SYNTHETIC_AUDIENCE_IDS[bannerKey]
            if (!audienceId) return null
            return (this.segmentationAudienceList || []).find((aud) => Number(aud?.id) === Number(audienceId)) || null
        },
        buildActivationExtra(segmentDefinition) {
            const automail = {
                limitOneMailing: Number(this.segmentationForm.messagesInBatch || 1),
                commonLimit: Number(this.segmentationForm.messagesPerDay || 20),
                intervalInMinutes: Math.max(4, Number(this.segmentationForm.minutesBetween || 5)),
                sendAfter: this.segmentationActivationDraft?.extra?.automail?.sendAfter || '12:00',
                sendBefore: this.segmentationActivationDraft?.extra?.automail?.sendBefore || '17:00',
                timezoneOffset: this.normalizeAutomailTimezoneOffset(this.segmentationActivationDraft?.extra?.automail?.timezoneOffset),
                sendAfterDate: this.segmentationForm.startDate || null,
                sendBeforeDate: this.segmentationForm.endDate || null,
                isDeleted: false,
                stopOnBan: false,
            }
            // Виджет выбирает канал по connectorId, а активация должна хранить
            // id канала в network-fixer — иначе селект «Канал отправки» в
            // настройках активации не находит канал и остаётся пустым.
            const channelId = resolveSubscribersGrowthSendingChannelId(
                this.resolveSegmentationSendChannelId(),
                this.project?.connectors || []
            )
            const extra = {
                automail,
                audienceRule: this.resolveSegmentationAudienceRule(segmentDefinition),
                sendChannelId: channelId,
                sendingSettings: {
                    type: 'channel',
                    id: channelId,
                    channelId,
                },
            }
            const filter = this.segmentationActivationDraft?.extra?.filter
            if (filter && typeof filter === 'object' && Object.keys(filter).length > 0) {
                extra.filter = { ...filter }
            }
            if (this.activeBannerKey === 'invite_unsubscribed' && this.filters.channel) {
                extra.subscribersGrowthMaxBotConnectorId = String(this.filters.channel)
            }
            return extra
        },
        getSegmentationScriptForPersist(textVariant) {
            const text = String(textVariant || '')
            if (this.activeBannerKey !== 'invite_unsubscribed') return text
            return applySubscribersGrowthBotLinkPlaceholder(text, this.segmentationBotTelegramLink)
        },
        mapSegmentationScriptsForDisplay(messageParts, bannerKey) {
            if (bannerKey !== 'invite_unsubscribed') return messageParts
            const link = this.segmentationBotTelegramLink
            return messageParts.map((part) => ({
                ...part,
                textVariant: restoreSubscribersGrowthBotLinkPlaceholder(part.textVariant || '', link),
            }))
        },
        async resolveWidgetMaxBotTelegramLink() {
            const connectorId = String(this.filters.channel || '').trim()
            if (!connectorId) return ''
            let link = getSubscribersGrowthMaxBotTelegramLink(connectorId, this.project?.connectors || [])
            if (!link) {
                const res = await getMaxBusinessBotTelegramLink({ connectorId })
                if (!res.error && res.data) {
                    link = normalizeSubscribersGrowthBotLink(res.data)
                }
            }
            return normalizeSubscribersGrowthBotLink(link)
        },
        async persistSegmentationMessageParts(messageId) {
            const parts = this.segmentationActivationDraft?.message?.messageParts || []
            for (const messagePart of parts) {
                const textVariant = this.getSegmentationScriptForPersist(messagePart.textVariant || '')
                if (messagePart._deleted && messagePart.id) {
                    const res = await deleteMessagePart({ id: Number(messagePart.id), projectId: this.projectId })
                    if (res.error) throw new Error(String(res.error.message || 'Не удалось удалить часть сообщения'))
                } else if (messagePart.id && !messagePart._deleted) {
                    const res = await updateMessagePart({
                        id: Number(messagePart.id),
                        projectId: this.projectId,
                        partNumber: Number(messagePart.partNumber || 1),
                        textVariant,
                    })
                    if (res.error) throw new Error(String(res.error.message || 'Не удалось обновить часть сообщения'))
                } else if (!messagePart._deleted) {
                    const res = await createMessagePart({
                        projectId: this.projectId,
                        messageId: Number(messageId),
                        partNumber: Number(messagePart.partNumber || 1),
                        textVariant,
                    })
                    if (res.error) throw new Error(String(res.error.message || 'Не удалось создать часть сообщения'))
                }
            }
        },
        goToChannelsSetup() {
            this.$router.push({ path: `/project/${this.projectId}`, hash: '#channels-tabs' })
        },
        isChartCellSelected(month) {
            if (!this.chartFilter) return false
            return this.chartFilter.month === month.month && this.chartFilter.year === month.year
        },
        async toggleChartFilter(month, type) {
            if (this.chartFilter && this.chartFilter.month === month.month && this.chartFilter.year === month.year && this.chartFilter.type === type) {
                await this.clearChartFilter()
                return
            }
            const start = moment(`${month.year}-${month.month}-01`, 'YYYY-M-D').startOf('month')
            const end = start.clone().endOf('month')
            this.chartFilter = {
                month: month.month,
                year: month.year,
                type,
                label: `${month.short} ${month.year}`,
                dateFrom: start.format('YYYY-MM-DD'),
                dateTo: end.format('YYYY-MM-DD'),
            }
            await this.applyFilters({ preserveChartFilter: true })
        },
        async clearChartFilter() {
            this.chartFilter = null
            await this.applyFilters()
        },
        async openClientSidebar(item) {
            const clientId = String(item.clientId || '').trim()
            if (!clientId) {
                this.$store.dispatch('callNotify', 'Не удалось определить клиента')
                return
            }
            this.activeClient = {
                clientId,
                name: item.name || 'Клиент',
                phone: item.phone || '—',
            }
            this.clientVisits = []
            this.clientVisitsError = ''
            await this.loadClientVisits()
            this.clientSidebarOpen = true
        },
        copyClientPhone() {
            if (!this.activeClient.phone || this.activeClient.phone === '—') return
            navigator.clipboard.writeText(this.activeClient.phone)
            this.$store.dispatch('callNotify', 'Телефон скопирован')
        },
        async loadClientVisits() {
            const clientId = String(this.activeClient.clientId || '').trim()
            if (!clientId) return
            this.clientVisitsLoading = true
            this.clientVisitsError = ''
            const response = await getClientVisitsHistoryData({ projectId: this.projectId, clientId })
            if (response.error) {
                this.clientVisitsError = 'Не удалось загрузить данные'
                this.$store.dispatch('callNotify', 'При загрузке истории посещений произошла ошибка ', { root: true })
            } else {
                this.clientVisits = response.data || []
            }
            this.clientVisitsLoading = false
        },
        async openSegmentationMaster(bannerKey) {
            this.activeBannerKey = bannerKey
            const definition = SEGMENT_DEFINITIONS.find((segment) => segment.key === bannerKey)
            if (!definition) return
            await this.ensureSegmentationAudiencesLoaded()
            this.segmentationDialogAudience = this.buildSegmentationSchemaAudience(bannerKey)
            if (!this.segmentationDialogAudience) {
                this.$store.dispatch('callNotify', `Не найдена аудитория #${SUBSCRIBERS_GROWTH_SYNTHETIC_AUDIENCE_IDS[bannerKey] || ''}`)
                return
            }
            await this.fetchSegmentationAudienceLists()
            this.segmentationBotTelegramLink = await this.resolveWidgetMaxBotTelegramLink()
            const currentSegment = this.segmentsByBanner[bannerKey]
            const channelOptions = this.segmentationChannelOptions
            const savedSendChannelId =
                currentSegment?.extra?.sendingSettings?.id ??
                currentSegment?.extra?.sendChannelId ??
                currentSegment?.extra?.sendingSettings?.channelId ??
                ''
            const savedWidgetChannelId = resolveSubscribersGrowthWidgetChannelId(
                savedSendChannelId,
                this.project?.connectors || []
            )
            const channelForForm =
                savedWidgetChannelId && channelOptions.some((c) => String(c.id) === savedWidgetChannelId)
                    ? savedWidgetChannelId
                    : channelOptions[0]?.id || ''
            const am = currentSegment?.extra?.automail || {}
            const tzNum = this.normalizeAutomailTimezoneOffset(am.timezoneOffset)

            let messageParts = [{ partNumber: 1, textVariant: definition.defaultScript, _id: uniqueId() }]
            if (currentSegment?.messageId) {
                const messageRes = await getMessage({ id: Number(currentSegment.messageId), projectId: this.projectId })
                if (!messageRes.error && Array.isArray(messageRes.messageParts) && messageRes.messageParts.length) {
                    messageParts = messageRes.messageParts
                        .slice()
                        .sort((a, b) => Number(a.partNumber || 0) - Number(b.partNumber || 0))
                        .map((el) => ({
                            id: el.id,
                            _id: uniqueId(),
                            partNumber: Number(el.partNumber || 1),
                            textVariant: el.textVariant || '',
                        }))
                }
            }
            messageParts = this.mapSegmentationScriptsForDisplay(messageParts, bannerKey)
            if (bannerKey === 'safe_mailing') {
                messageParts = messageParts.map((part) => {
                    const trimmed = String(part.textVariant || '').trim()
                    if (
                        !trimmed ||
                        trimmed === SAFE_MAILING_SCRIPT_PLACEHOLDER ||
                        trimmed === LEGACY_SAFE_MAILING_DEFAULT_SCRIPT
                    ) {
                        return { ...part, textVariant: '' }
                    }
                    return part
                })
            }
            this.segmentationForm = {
                name: currentSegment?.name || definition.defaultActivationName,
                channel: channelForForm,
                intervalFrom: am.sendAfter || '12:00',
                intervalTo: am.sendBefore || '17:00',
                timeZone: String(tzNum),
                messagesInBatch: Number(am.limitOneMailing || 1),
                messagesPerDay: Number(am.commonLimit || 20),
                minutesBetween: Number(am.intervalInMinutes || 5),
                startDate: am.sendAfterDate || '',
                endDate: am.sendBeforeDate || '',
            }
            this.segmentationActivationDraft = {
                ...this.segmentationActivationDraft,
                audienceId: null,
                extra: {
                    filter: currentSegment?.extra?.filter ? { ...currentSegment.extra.filter } : {},
                    automail: {
                        sendAfter: am.sendAfter || '12:00',
                        sendBefore: am.sendBefore || '17:00',
                        timezoneOffset: tzNum,
                    },
                },
                message: {
                    ...this.segmentationActivationDraft.message,
                    messageParts,
                },
            }
            this.initSegmentationAudienceFilterValues(currentSegment)
            this.segmentationDialog = true
        },
        cancelSegmentationChanges() {
            this.segmentationDialog = false
            this.segmentationDialogAudience = null
            this.$store.dispatch('callNotify', 'Изменения не сохранены. Возврат на страницу виджета')
        },
        async saveSegmentAndRefresh(autoMailingEnabled) {
            if (!this.activeBannerKey) return
            this.segmentationLoading = true
            try {
                const segmentDefinition = SEGMENT_DEFINITIONS.find((segment) => segment.key === this.activeBannerKey)
                const currentSegment = this.segmentsByBanner[this.activeBannerKey]
                if (!segmentDefinition) throw new Error('Неизвестный тип сегмента')
                if (!this.canSubmitSegmentation) throw new Error('Заполните настройки сегментации')

                if (!currentSegment) {
                    const messageRes = await createMessage({
                        projectId: this.projectId,
                        name: `${this.segmentationForm.name} — сообщение`,
                        group: SEGMENT_GROUP,
                    })
                    if (messageRes.error || !messageRes.data) throw new Error(messageRes.error?.message || 'Не удалось создать сообщение для сегмента')
                    await this.persistSegmentationMessageParts(messageRes.data.id)
                    const audienceId = SUBSCRIBERS_GROWTH_SYNTHETIC_AUDIENCE_IDS[this.activeBannerKey]
                    if (!audienceId) throw new Error('Не удалось определить аудиторию для сегмента')

                    const activationRes = await createActivation({
                        projectId: this.projectId,
                        name: this.segmentationForm.name,
                        group: SEGMENT_GROUP,
                        description: `Сегментация для отчета "${segmentDefinition.title}"`,
                        messageId: messageRes.data.id,
                        audienceId,
                        isRunning: Boolean(autoMailingEnabled),
                        extra: this.buildActivationExtra(segmentDefinition),
                        tags: ['subscribers_growth', `${SEGMENT_TAG_PREFIX}${this.activeBannerKey}`],
                    })
                    if (activationRes.error || !activationRes.data) throw new Error(activationRes.error?.message || 'Не удалось создать сегмент')
                } else {
                    const messageRes = await getMessage({ id: Number(currentSegment.messageId), projectId: this.projectId })
                    if (messageRes.error) {
                        throw new Error(messageRes.error?.message || 'Не удалось загрузить сообщение сегмента')
                    }
                    const updateMsgRes = await updateMessage({
                        id: Number(currentSegment.messageId),
                        projectId: this.projectId,
                        name: `${this.segmentationForm.name} — сообщение`,
                        group: SEGMENT_GROUP,
                    })
                    if (updateMsgRes.error) throw new Error(String(updateMsgRes.error?.message || 'Не удалось обновить сообщение сегмента'))
                    await this.persistSegmentationMessageParts(Number(currentSegment.messageId))
                    const updateRes = await updateActivation({
                        id: Number(currentSegment.id),
                        projectId: this.projectId,
                        name: this.segmentationForm.name,
                        description: `Сегментация для отчета "${segmentDefinition.title}"`,
                        group: SEGMENT_GROUP,
                        messageId: Number(currentSegment.messageId),
                        extra: this.buildActivationExtra(segmentDefinition),
                        tags: ['subscribers_growth', `${SEGMENT_TAG_PREFIX}${this.activeBannerKey}`],
                    })
                    if (updateRes.error) throw new Error(updateRes.error.message || 'Не удалось сохранить сегмент')
                    if (Boolean(currentSegment.isRunning) !== Boolean(autoMailingEnabled)) {
                        const runningRes = await toogleIsRunning({
                            projectId: this.projectId,
                            id: Number(currentSegment.id),
                            isRunning: Boolean(autoMailingEnabled),
                        })
                        if (runningRes.error) throw new Error(runningRes.error.message || 'Не удалось изменить статус рассылки')
                    }
                }
                await this.loadSegments()
                this.segmentationDialog = false
                this.segmentationDialogAudience = null
                await this.applyFilters()
                this.$store.dispatch(
                    'callNotify',
                    `Сохранено. Авторассылка ${autoMailingEnabled ? 'включена' : 'выключена'}. Расчеты обновлены`
                )
            } catch (e) {
                this.$store.dispatch('callNotify', e.message || 'Ошибка сохранения сегмента')
            } finally {
                this.segmentationLoading = false
            }
        },
        openStatistics(bannerKey) {
            if (!bannerKey || !this.projectId) return
            const tagId = `${SEGMENT_TAG_PREFIX}${bannerKey}`
            const tagsSerialized = qs.stringify([tagId])
            const url = `${window.location.origin}/project/${this.projectId}/GCB2?section=overview&tags=${encodeURIComponent(tagsSerialized)}`
            window.open(url, '_blank')
        },
        async applyFilters({ preserveChartFilter = false } = {}) {
            if (!this.filters.channel) {
                this.$store.dispatch('callNotify', 'Выберите канал')
                return
            }
            if (!preserveChartFilter) {
                this.chartFilter = null
            }
            this.loading = true
            try {
                await this.loadReport()
            } catch (e) {
                this.$store.dispatch('callNotify', e.message || 'Ошибка при загрузке отчета')
            } finally {
                this.loading = false
            }
        },
        async resetFilters() {
            this.filters.status = 'all'
            this.periodDates = [...defaultDates]
            this.tablePage = 1
            this.itemsPerPage = 10
            this.chartFilter = null
            await this.applyFilters()
        },
    },
    beforeDestroy() {
        this.removeMarginFromContent()
        this.removeMarginFromBreadcrumbs()
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
@import '@/assets/styles/main.sass'
@import @/assets/styles/GCB2.sass

.sg-client-sidebar-backdrop
    position: fixed
    top: 56px
    left: 0
    right: 0
    bottom: 0
    background: rgba(0, 0, 0, 0.2)
    z-index: 100

.sidebar-spacer
    max-width: 420px
    min-width: 420px
    height: 100vh
    flex-grow: 1
    overflow-y: auto
    overflow-x: hidden
    background-color: transparent

::v-deep .subscribers-growth-client-drawer.v-navigation-drawer
    will-change: initial
::v-deep aside.subscribers-growth-client-drawer
    z-index: 101 !important
::v-deep .subscribers-growth-client-drawer .v-navigation-drawer__content::-webkit-scrollbar
    display: none

.sidebar-header-wrapper
    position: fixed
    margin-top: 56px
    z-index: 103
    display: flex
    width: 100%
    flex-direction: row
    justify-items: flex-end
    border-left: 1px solid $light-gray-2

.sidebar-header
    padding-left: 16px
    padding-right: 16px
    width: 100%
    height: 100%
    background-color: white

.sidebar-client-headline
    min-width: 0

.sidebar-client-name
    font-size: 16px
    font-weight: 500
    line-height: 1.35

.sidebar-client-phone
    margin-top: 4px
    font-size: 12px
    color: $gray

.sidebar-content
    margin-top: 100px

.sidebar-content ::v-deep .v-expansion-panel
    border-radius: 0
    border-top: 1px solid $light-gray-2
    border-bot: 1px solid $light-gray-2
    box-shadow: none !important
    &:last-child
        border-bottom: 1px solid $light-gray-2

.sidebar-content ::v-deep .v-expansion-panel::after
    box-shadow: none !important
    border: none !important

.sidebar-content ::v-deep .v-expansion-panel::before
    box-shadow: none !important

.sidebar-content ::v-deep .v-expansion-panels
    border-left: 1px solid $light-gray-2

.title
    margin-bottom: 16px
.filters
    gap: 12px
.select-input
    width: 190px
.period-input
    width: 290px
.actions-row
    align-items: center
.channels-recommend-banner
    display: grid
    grid-template-columns: 55px 1fr
    grid-template-areas: "icon content" "actions actions"
    column-gap: 12px
    row-gap: 10px
    align-items: flex-start
    border: 1px solid #d9dce1
    border-radius: 8px
    padding: 16px
    background: #fff
    width: 100%
    &__icon
        width: 55px
        height: 55px
        grid-area: icon
        border: 1px dashed #378eff
        border-radius: 50%
        display: flex
        align-items: center
        justify-content: center
        flex-shrink: 0
        background: #edf4ff
    &__icon--rocket
        background: #eaf3ff
    &__rocket
        font-size: 28px
        line-height: 28px
        display: block
    &__content
        grid-area: content
        min-width: 0
    &__actions
        grid-area: actions
        display: flex
        justify-content: flex-end
    &__title
        font-size: 18px
        font-weight: 700
        line-height: 1.1
        letter-spacing: -0.03em
        color: #2a3b51
        margin-bottom: 6px
    &__text
        font-size: 14px
        line-height: 1.3
        color: rgba(42, 59, 81, 0.87)
        margin-bottom: 10px
    &__btn
        box-shadow: none !important
.widget-cards
    margin-top: 4px
    display: flex
    gap: 12px
    flex-wrap: nowrap
    overflow-x: auto
    align-items: stretch
.widget-card-col
    flex: 1 1 0
    min-width: 320px
    display: flex
.widget-card
    padding: 16px
    min-height: 116px
    display: flex
    flex-direction: column
    justify-content: space-between
    width: 100%
    &__head
        display: flex
        align-items: center
        gap: 10px
    &__icon
        width: 55px
        height: 55px
        min-width: 55px
        border: 1px dashed #378eff
        border-radius: 50%
        background: #eaf3ff
        display: flex
        align-items: center
        justify-content: center
    &__emoji
        font-size: 28px
        line-height: 28px
        display: block
    &__title
        font-weight: 600
        font-size: 18px
        line-height: 1.25
    &__actions
        display: flex
        align-items: center
        justify-content: flex-end
        gap: 8px
.summary
    font-size: 16px
    line-height: 1.4
    display: flex
    align-items: center
    gap: 6px
    &__label
        font-weight: 600
    &__percent
        color: #333
    &__hint-icon
        cursor: pointer
.chart-filter-chip
    display: inline-flex
    align-items: center
    gap: 4px
    background: #f1f5fe
    border: 1px solid #d9e3fb
    border-radius: 16px
    padding: 4px 8px
    font-size: 13px
.status-cell
    display: flex
    align-items: center
    gap: 8px
.status-dot
    width: 8px
    height: 8px
    border-radius: 50%
.green
    background: #4caf50
.red
    background: #d24d57
.graph-title
    font-weight: 500
    font-size: 28px
    margin-top: 8px
.metrics-chart-wrap
    border: 1px solid #e1e5e9
    border-radius: 4px
    background: #fff
    overflow-x: auto
.chart-main-row
    display: flex
    align-items: stretch
    min-width: min-content
.chart-sidebar
    flex: 0 0 300px
    max-width: 340px
    background: #f8f9fa
    border-right: 2px solid #dee2e6
    padding: 12px 14px
    display: flex
    align-items: center
    position: sticky
    left: 0
    z-index: 2
.chart-controls
    display: flex
    align-items: center
    gap: 10px
    width: 100%
.chart-controls-left
    display: flex
    flex-direction: column
    align-items: flex-start
    gap: 10px
    flex: 1
    min-width: 0
.chart-mode-input
    width: 210px
.metric-name-label
    font-size: 14px
    font-weight: 400
    color: #333
.chart-scale
    flex-shrink: 0
.scale-labels
    position: relative
    height: 124px
    min-width: 36px
.scale-label
    position: absolute
    right: 0
    transform: translateY(-50%)
    font-size: 12px
    color: #666
    text-align: right
    line-height: 1
.chart-periods-row
    display: flex
    flex: 1
    align-items: stretch
    margin-top: 30px
.chart-cell
    flex: 0 0 72px
    width: 72px
    min-width: 72px
    padding: 0
    text-align: center
    vertical-align: middle
    background: #fff
    display: flex
    flex-direction: column
    align-items: center
.chart-cell--selected
    box-shadow: inset 0 0 0 2px #666
.mini-chart
    width: 100%
    height: 124px
    display: flex
    align-items: flex-end
    justify-content: center
    position: relative
    cursor: pointer
.chart-grid-lines
    position: absolute
    top: 0
    left: 0
    right: 0
    bottom: 0
    pointer-events: none
.grid-line
    position: absolute
    left: 0
    right: 0
    height: 1px
    background-color: #e0e0e0
    opacity: 0.6
    transform: translateY(-50%)
.chart-bars-wrap
    display: flex
    align-items: flex-end
    justify-content: center
    gap: 5px
    height: 100%
    width: 100%
    padding: 0 4px
    position: relative
    z-index: 1
.chart-bar
    width: 16px
    border-radius: 2px 2px 0 0
    transition: box-shadow 0.2s ease, filter 0.2s ease
    position: relative
    align-self: flex-end
.chart-bar--subs
    background: linear-gradient(to top, #3d8c40, #69b85d)
.chart-bar--unsubs
    background: linear-gradient(to top, #b54545, #d75f5f)
.period-label
    font-size: 12px
    padding: 6px 0 8px
    color: #666
.chart-tooltip-body
    font-size: 13px
    line-height: 1.45
    text-align: left
    div
        color: white
.chart-tooltip-title
    font-weight: 600
    margin-bottom: 4px
.chart-tooltip-pos
    color: #2e7d32
    font-weight: 600
.chart-tooltip-neg
    color: #c62828
    font-weight: 600
.legend
    font-size: 14px
    margin-top: 8px
    display: flex
    justify-content: flex-end
.legend-dot
    display: inline-block
    width: 10px
    height: 10px
    border-radius: 2px
    margin-right: 6px
/** v-tooltip между кнопками ломает .v-btn + .v-btn у Vuetify — явный gap */
.segmentation-dialog-actions
    display: flex
    flex-wrap: wrap
    align-items: center
    gap: 12px
    padding-top: 0
    > .v-btn,
    > .v-tooltip
        margin-left: 0 !important
        margin-right: 0 !important

.segmentation-form-grid
    display: grid
    grid-template-columns: 1fr 320px
    gap: 16px
.segmentation-form-main
    min-width: 0
    /** MessageSettings: слайдер частей слева от редактора (как в оригинале), без переноса строки */
    &::v-deep form > .v-row.ma-0
        display: flex !important
        flex-direction: row !important
        flex-wrap: nowrap !important
        align-items: flex-start !important
    &::v-deep .message-parts-slider
        flex: 0 0 auto
    &::v-deep form > .row.ma-0 > .ml-4
        display: flex
        flex-direction: column
        align-items: stretch
        flex: 1 1 0
        flex-grow: 1
        min-width: 0
        width: auto
    &::v-deep .message-parts-editor
        width: 100% !important
        max-width: 100% !important
        min-width: 0
        flex-grow: 1
.segmentation-form-side
    min-width: 0
    display: flex
    flex-direction: column
    align-items: stretch
    gap: 12px
    > span
        display: block
        width: 100%
    > .segmentation-time-limits
        width: 100%
.segmentation-time-limits
    width: 100%
    margin-top: 4px
    &::v-deep form
        width: 100%
    &::v-deep .mb-3
        width: 100%
    &::v-deep .dashboard
        display: block
    &::v-deep .d-flex.settings-row
        display: flex !important
        flex-direction: column !important
        align-items: stretch !important
        gap: 0
        width: 100%
    &::v-deep .d-flex.settings-row > div
        max-width: 100% !important
        width: 100% !important
    &::v-deep .settings-row.ma-0
        margin-left: 0 !important
        margin-right: 0 !important
        flex-direction: column !important
        flex-wrap: nowrap !important
        width: 100%
    &::v-deep .settings-row.ma-0 > *
        width: 100% !important
        max-width: 100% !important
    &::v-deep .d-flex.settings-row > .settings-input
        width: 100% !important
        max-width: 100% !important
        display: block
    &::v-deep .select-input
        width: 100% !important
    &::v-deep .base-input-outlined-wrapper
        width: 100%
    &::v-deep .base-input-outlined,
    &::v-deep .v-input
        width: 100% !important
    &::v-deep .v-text-field__details
        display: none
    &::v-deep .warning-text
        font-size: 12px
        margin-top: -4px
.segmentation-audience-params
    &::v-deep .audience.ml-2
        margin-left: 0 !important
.segmentation-section-title
    font-size: 14px
    font-weight: 700
    color: #6f7782
    text-transform: uppercase
    margin: 8px 0
.segmentation-rule-row
    display: flex
    align-items: center
    gap: 8px
    flex-wrap: wrap
.segmentation-inline-input
    max-width: 180px
.segmentation-script-header
    margin-top: 8px
    margin-bottom: 8px
    display: flex
    align-items: center
    justify-content: space-between
    font-size: 14px
    font-weight: 600
.segmentation-side-title
    font-size: 12px
    color: #7d8790
    margin-bottom: 8px
.segmentation-warning-text
    display: block
    margin-top: 6px
    font-size: 12px
    color: #d24d57
.error-state
    color: #d24d57
</style>